import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Loader from "components/loader";
import { useParams } from "react-router-dom";
import Appconfig from '../../config/config'
import { getEventMarketBets } from "../../redux/slice/eventMarketBets/eventMarketBetsSlice";
const UserShowBets = () => {
    const dispatch = useDispatch();
    const { match_id, market_id, is_fancy } = useParams();
    const { data, loading } = useSelector((state) => state.eventMarketBets);
    // console.log('data:', data)
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { userdata } = useSelector((state) => state.authSlice);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [filteredData, setFilteredData] = useState();

    const [eventType, setEventType] = useState("4");
    const [status, setStatus] = useState("Settled");
    const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'day'));
    const [toDate, setToDate] = useState(dayjs());
    const paginatedData = filteredData?.slice(startIndex, endIndex);
    let locale = {
        emptyText: 'No data!',
    };
    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'index',
            render: (_, record, index) => (
                <span>{(index + 1)}</span>
            )
        },
        {
            title: "Client",
            dataIndex: "user_name",
            // sorter: true,
            width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {userdata.user_name}
                </span>
            ),
        },
        ...Appconfig.userTypes
            .filter(userType => userType?.title !== 'User')
            .map(userType => ({
                title: userType.title,
                dataIndex: userType.alias,
                // sorter: true,
                width: "25%",
                render: (_, record) => (
                    <span className="font-extrabold text-[#212529] text-[0.813rem]">
                        {record.masters.find(master => master?.user_type == userType?.title)?.user_name || '-'}
                    </span>
                ),
            })),
        {
            title: "Description",
            dataIndex: "event_name",
            // sorter: true,
            width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.event_name}
                </span>
            ),
        },
        {
            title: "Selection",
            dataIndex: "name",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.runner_name}
                </span>
            ),
        },
        {
            title: "Type",
            dataIndex: "betting_type",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.betting_type == 'Match' ? 'Match Odds' : 'Fancy'}
                </span>
            ),
        },
        {
            title: "Odds",
            dataIndex: "price_val",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {Number(record.price_val).toFixed(2)}
                </span>
            ),
        },
        {
            title: "Stack",
            dataIndex: "name",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {Number(record.stake).toFixed(2)}
                </span>
            ),
        },
        {
            title: "Place Time",
            dataIndex: "name",
            // sorter: true,
            // width: "25%",
            render: (_, record) => {
                return (
                    <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                        {new Date(record.createdAt).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        })}
                    </span>
                );
            },
        },
        {
            title: 'P_L',
            dataIndex: 'P_L	',
            align: 'right',
            // width: '12%',
            render: (_, record) => (
                <span className=' font-extrabold'>{Number(record?.p_l).toFixed(2)}</span>
            ),
        },

        {
            title: 'Profit',
            dataIndex: 'profit',
            align: 'right',
            // width: '12%',
            render: (_, record) => (
                <span className={`${record.bet_result == 'Plus' ? 'text-[#508d0e]' : 'text-[#d50000]'} font-extrabold`}>{
                    record.bet_result == 'Plus' ? Number(record?.profit).toFixed(2) : '-'
                }</span>
            ),
        },
        {
            title: 'Loss',
            dataIndex: 'loss',
            align: 'right',
            // width: '12%',
            render: (_, record) => (
                <span className={`${record.bet_result == 'Plus' ? 'text-[#508d0e]' : 'text-[#d50000]'} font-extrabold`}>{
                    record.bet_result == 'Plus' ? '-' : Number(record?.loss).toFixed(2)
                }</span>
            ),
        },
        {
            title: "Result",
            dataIndex: "bet_result",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.bet_result}
                </span>
            ),
        },
        {
            title: "Status",
            dataIndex: "Status",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.status == 'Settled' ? 'Close' : 'Open'}
                </span>
            ),
        },
        {
            title: "IP",
            dataIndex: "IP",
            // sorter: true,
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#212529] text-[0.813rem] ">
                    {record.ip_address}
                </span>
            ),
        },
    ];
    useEffect(() => {
        if (match_id) {
            const data = {
                match_id: match_id,
                market_id: market_id,
                is_fancy: is_fancy
            }
            dispatch(getEventMarketBets(data))
        }
    }, [match_id])
    // console.log('data:', data)
    return (
        <>
            {
                loading && <Loader />
            }
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                    <div className='col-span-12'>
                        <div className='relative w-full'>
                            {/* <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Match Details</p> */}
                        </div>
                        <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                            <div className='col-span-12'>
                                <Table
                                    locale={locale}
                                    columns={columns}
                                    bordered
                                    dataSource={data}
                                    pagination={false}
                                />
                            </div>
                        </div>

                    </div >

                </div >
            </div >
        </>
    )
}
export default UserShowBets